import { useCallback } from 'react';

import { useCluster } from '@cast/shared-cluster-context-data-access';
import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

// Per-cluster atoms cached by cluster id so all consumers of the same cluster
// share one reactive state — avoiding the split-brain bug where two
// usePersistentState instances each hold their own local copy and don't see
// each other's writes.
const atomCache = new Map<
  string,
  ReturnType<typeof atomWithStorage<boolean>>
>();

const getAtom = (clusterId: string) => {
  if (!atomCache.has(clusterId)) {
    atomCache.set(
      clusterId,
      atomWithStorage(`auto-optimization-wizard-hidden:${clusterId}`, false)
    );
  }
  return atomCache.get(clusterId)!;
};

export const useOptimizeBannerVisibility = () => {
  const { cluster } = useCluster();
  const [hidden, setHiddenState] = useAtom(getAtom(cluster.id));

  const setHidden = useCallback(() => {
    setHiddenState(true);
  }, [setHiddenState]);

  return { hidden, setHidden };
};
